/*
 *   File : progress-bar.jsx
 *   Author : https://evoqins.com
 *   Description :
 *   Integrations :
 *   Version : 1.0.0
 */

import React from "react";

export default function ProgressBar(props) {
  return (
    <>
      {props.type === 2 ? (
        <div className="progressBar-2 e-bg-gainsboro e-border-radius-24 w-100">
          <div
            className="d-flex e-bg-progressBar-linear"
            style={{ width: `${props.width}` }}
          ></div>
        </div>
      ) : (
        <div
          style={{ backgroundColor: "#E6D9FF", padding:'2px'}}
          className={`progressBar e-border-radius-16 d-flex w-100 ${props.ClassName}`}
        >
          {props.segments.map((seg, idx) => (
            <div
              key={idx}
              title={`${seg.label} ${seg.value_text}`}
              style={{
                width: `${seg.value}%`,
                backgroundColor: seg.color || "#ccc",
                minWidth: 1,
              }}
            >
              <span className="visually-hidden">{seg.label}</span>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
